module.exports = __webpack_public_path__ + "img/ic_forum_banner.898daa63.png";